import { FC } from 'react';
import { TableColumn, TableSorting, TableSelection } from '../types';

interface TableHeaderProps {
  columns: TableColumn[];
  sorting?: TableSorting;
  onSortingChange?: (sorting: TableSorting) => void;
  selectable?: boolean;
  selection?: TableSelection;
  onSelectionChange?: (selection: TableSelection) => void;
  totalRows: number;
}

export const TableHeader: FC<TableHeaderProps> = ({
  columns,
  sorting,
  onSortingChange,
  selectable,
  selection,
  onSelectionChange,
  totalRows,
}) => {
  const handleSort = (column: TableColumn) => {
    if (!column.sortable || !onSortingChange) return;

    const newDirection = 
      sorting?.field === column.value && sorting.direction === 'asc' ? 'desc' : 'asc';
    
    onSortingChange({
      field: column.value,
      direction: newDirection,
    });
  };

  const handleSelectAll = (checked: boolean) => {
    if (!onSelectionChange || !selection) return;

    onSelectionChange({
      ...selection,
      selectAll: checked,
      selectedRows: checked ? Array.from({ length: totalRows }, (_, i) => i) : [],
    });
  };

  const getSortIcon = (column: TableColumn) => {
    if (!column.sortable || sorting?.field !== column.key) {
      return (
        <i className="fas fa-sort text-muted me-1" style={{ fontSize: '0.8em' }}></i>
      );
    }

    return sorting.direction === 'asc' ? (
      <i className="fas fa-sort-up text-primary me-1" style={{ fontSize: '0.8em' }}></i>
    ) : (
      <i className="fas fa-sort-down text-primary me-1" style={{ fontSize: '0.8em' }}></i>
    );
  };

  return (
    <thead>
      <tr>
        {selectable && (
          <th className="w-50px">
            <div className="form-check form-check-sm form-check-custom form-check-solid">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selection?.selectAll || false}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
            </div>
          </th>
        )}
        
        {columns
          .filter(col => col.visible !== false)
          .map((column) => (
            <th
              key={column.key}
              className={`
                text-muted fw-bolder text-uppercase fs-7
                ${column.sortable ? 'cursor-pointer user-select-none' : ''}
                ${column.align === 'center' ? 'text-center' : ''}
                ${column.align === 'right' ? 'text-end' : ''}
              `}
              style={{ width: column.width }}
              onClick={() => handleSort(column)}
            >
              <div className="d-flex align-items-center">
                {column.sortable && getSortIcon(column)}
                <span>{column.key}</span>
              </div>
            </th>
          ))}
      </tr>
    </thead>
  );
};
